// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".will-unsubscribe[data-v-443447f2]{color:#ebb38a}", ""]);
// Exports
module.exports = exports;
